import React from 'react';
import PropTypes from 'prop-types';

function headline({ productHeadline }) {
  return productHeadline && <div className="pdp__headline">{productHeadline}</div>;
}

headline.propTypes = {
  productHeadline: PropTypes.string.isRequired,
};

export default headline;
